import { createContext, useContext } from "react";

/**
 * The header bar owns one slot; whichever `PageHeader` is mounted renders its
 * title, subtitle and actions into it, so the page identity and the global
 * scope selectors share a single row (see AppHeader).
 *
 * `claim` is called by PageHeader on mount/unmount so the bar knows whether to
 * fall back to a route-derived title. Only one PageHeader is ever mounted at a
 * time in practice - tab panels render exclusively.
 */
export interface PageChrome {
  slot: HTMLElement | null;
  claim: (delta: 1 | -1) => void;
  /**
   * Slot inside the sidebar's "Premises & Screens" group. The premise editor
   * renders its full section tree here, so there is exactly one nav on screen
   * instead of two that half-agree.
   */
  navSlot: HTMLElement | null;
  claimNav: (delta: 1 | -1) => void;
}

export const PageChromeCtx = createContext<PageChrome | null>(null);

export function usePageChrome(): PageChrome | null {
  return useContext(PageChromeCtx);
}
